import { GhostButton } from "../Primitives";
import { MultiSelectDropdown } from "../MultiSelectDropdown";
import { SITE_STATUSES, SHIFT_STATUSES } from "./shiftUtils";

export function RosterFilters({
  clients,
  siteOptions,
  clientFilter,
  setClientFilter,
  siteFilter,
  setSiteFilter,
  siteStatusFilter,
  setSiteStatusFilter,
  shiftStatusFilter,
  setShiftStatusFilter,
  hideEmptySites,
  setHideEmptySites,
  needsCoverageOnly,
  setNeedsCoverageOnly,
  weekStart,
  days,
  moveRange,
  resetToToday,
}) {
  const siteStatusOptions = SITE_STATUSES.map((s) => ({ v: s.v, label: s.label })).map((s) => ({ value: s.v, label: s.label }));
  const shiftStatusOptions = SHIFT_STATUSES.map((s) => ({ value: s.v, label: s.label }));
  const clientOptions = (clients || []).map((c) => ({ value: c, label: c }));

  return (
    <div className="flex flex-wrap items-end justify-between gap-4">
      <div className="flex flex-wrap items-end gap-3" data-testid="roster-filters">
        <div>
          <div className="label-mute mb-1">Client</div>
          <MultiSelectDropdown
            testId="filter-client"
            label="All clients"
            options={clientOptions}
            selected={clientFilter}
            onChange={(v) => { setClientFilter(v); setSiteFilter([]); }}
            searchable
            triggerClassName="min-w-[200px]"
            emptyHint="No clients yet"
          />
        </div>
        <div>
          <div className="label-mute mb-1">
            Site
            {clientFilter.length > 0 && <span className="text-[#0A84FF] ml-1.5">· linked</span>}
          </div>
          <MultiSelectDropdown
            testId="filter-site"
            label="All sites"
            options={siteOptions}
            selected={siteFilter}
            onChange={setSiteFilter}
            searchable
            triggerClassName="min-w-[220px]"
            emptyHint="No sites match"
          />
        </div>
        {(clientFilter.length > 0 || siteFilter.length > 0) && (
          <button
            data-testid="clear-filters"
            onClick={() => { setClientFilter([]); setSiteFilter([]); }}
            className="text-xs uppercase tracking-widest text-zinc-500 hover:text-[#FF3B30] pb-2"
          >
            Clear
          </button>
        )}
        <div>
          <div className="label-mute mb-1">Site Status</div>
          <MultiSelectDropdown
            testId="filter-site-status"
            label="Site Status"
            options={siteStatusOptions}
            selected={Array.from(siteStatusFilter)}
            onChange={(arr) => setSiteStatusFilter(new Set(arr))}
            triggerClassName="min-w-[160px]"
          />
        </div>
        <div>
          <div className="label-mute mb-1">Shift Status</div>
          <MultiSelectDropdown
            testId="filter-shift-status"
            label="Shift Status"
            options={shiftStatusOptions}
            selected={Array.from(shiftStatusFilter)}
            onChange={(arr) => setShiftStatusFilter(new Set(arr))}
            triggerClassName="min-w-[180px]"
          />
        </div>
        {typeof setHideEmptySites === "function" && (
          <label
            className="flex items-center gap-2 pb-2 select-none cursor-pointer"
            data-testid="filter-hide-empty-sites-label"
          >
            <input
              type="checkbox"
              className="accent-[#FF3B30]"
              checked={!!hideEmptySites}
              onChange={(e) => setHideEmptySites(e.target.checked)}
              data-testid="filter-hide-empty-sites"
            />
            <span className="text-xs uppercase tracking-widest text-zinc-400">
              Hide empty sites
            </span>
          </label>
        )}
        {typeof setNeedsCoverageOnly === "function" && (
          <label
            className="flex items-center gap-2 pb-2 select-none cursor-pointer"
            data-testid="filter-needs-coverage-label"
            title="Show only sites with open (unassigned) or understaffed shifts in the current window"
          >
            <input
              type="checkbox"
              className="accent-[#FF9F0A]"
              checked={!!needsCoverageOnly}
              onChange={(e) => setNeedsCoverageOnly(e.target.checked)}
              data-testid="filter-needs-coverage"
            />
            <span className="text-xs uppercase tracking-widest text-zinc-400">
              Needs coverage only
            </span>
          </label>
        )}
      </div>
      <div className="flex items-end gap-3">
        <div>
          <div className="label-mute mb-1">Range</div>
          <div className="font-display text-xl uppercase font-bold tracking-tight">
            {weekStart.toLocaleDateString(undefined, { month: "short", day: "numeric" })} —{" "}
            {days[days.length - 1].toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" })}
          </div>
        </div>
        <div className="flex gap-2 pb-1">
          <GhostButton onClick={() => moveRange(-1)}>← Prev</GhostButton>
          <GhostButton onClick={resetToToday}>Today</GhostButton>
          <GhostButton onClick={() => moveRange(1)}>Next →</GhostButton>
        </div>
      </div>
    </div>
  );
}
